import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function CountdownTimer() {
  // Start from 23:59:57
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 57
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev; // Stop at 0
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="py-6 md:py-12 bg-white" data-id="element-79">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <FadeIn data-id="element-81">
          <div className="bg-rose-50 border-2 border-rose-200 rounded-2xl md:rounded-3xl p-4 md:p-8 text-center relative overflow-hidden" data-id="element-82">
            {/* Progress bar background */}
            <div className="absolute bottom-0 left-0 h-1.5 md:h-2 bg-slate-200 w-full" data-id="element-83">
              <div className="h-full bg-aqua-500 w-[68%] transition-all duration-1000 relative" data-id="element-84">
                <div className="absolute -top-6 md:-top-8 right-0 text-[10px] md:text-xs font-bold text-aqua-700 bg-aqua-100 px-1.5 py-0.5 md:px-2 md:py-1 rounded translate-x-1/2" data-id="element-85">
                  68%
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-1.5 md:gap-2 text-rose-600 font-bold tracking-wider uppercase text-[10px] md:text-sm mb-2 md:mb-4" data-id="element-86">
              <Timer className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-87" />
              EL PRECIO DE LANZAMIENTO TERMINA EN:
            </div>

            <div className="flex justify-center items-center gap-2 md:gap-4 mb-3 md:mb-6" data-id="element-88">
              <div className="flex flex-col items-center" data-id="element-89">
                <div className="bg-white text-rose-600 font-display font-black text-2xl md:text-5xl w-12 h-12 md:w-20 md:h-20 flex items-center justify-center rounded-lg md:rounded-xl shadow-sm border border-rose-100" data-id="element-90">
                  {formatTime(timeLeft.hours)}
                </div>
                <span className="text-[10px] md:text-xs font-bold text-rose-400 mt-1 md:mt-2 uppercase" data-id="element-91">
                  Horas
                </span>
              </div>
              <span className="text-xl md:text-3xl font-black text-rose-300 pb-4 md:pb-6" data-id="element-92">
                :
              </span>
              <div className="flex flex-col items-center" data-id="element-93">
                <div className="bg-white text-rose-600 font-display font-black text-2xl md:text-5xl w-12 h-12 md:w-20 md:h-20 flex items-center justify-center rounded-lg md:rounded-xl shadow-sm border border-rose-100" data-id="element-94">
                  {formatTime(timeLeft.minutes)}
                </div>
                <span className="text-[10px] md:text-xs font-bold text-rose-400 mt-1 md:mt-2 uppercase" data-id="element-95">
                  Minutos
                </span>
              </div>
              <span className="text-xl md:text-3xl font-black text-rose-300 pb-4 md:pb-6" data-id="element-96">
                :
              </span>
              <div className="flex flex-col items-center" data-id="element-97">
                <div className="bg-white text-rose-600 font-display font-black text-2xl md:text-5xl w-12 h-12 md:w-20 md:h-20 flex items-center justify-center rounded-lg md:rounded-xl shadow-sm border border-rose-100" data-id="element-98">
                  {formatTime(timeLeft.seconds)}
                </div>
                <span className="text-[10px] md:text-xs font-bold text-rose-400 mt-1 md:mt-2 uppercase" data-id="element-99">
                  Segundos
                </span>
              </div>
            </div>

            <p className="text-slate-700 font-medium text-sm md:text-lg mb-2 md:mb-4" data-id="element-100">
              Después sube <strong className="text-rose-600" data-id="element-101">$8.000 ARS</strong>{' '}
              y no vuelve a bajar.
            </p>

            <div className="text-xs md:text-sm text-slate-500 font-medium pb-2" data-id="element-102">
              Cupos al precio de lanzamiento — 68% tomados
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}